<div class="stores-list-container flex flex-column gap-3 w-full">
	@if (selectedComponent(); as componentClass) {
		<ng-container
			*ngComponentOutlet="
				componentClass;
				inputs: {
					stores: currentStores(),
					translations: translations,
					callback: strategy.callback
				}
			"
		></ng-container>
	}
</div>
